"use strict";
import ActivityStreamHelper from "../helpers/activity_stream";
import AuditFlagReview from "./factoring/audit_flag_review";
import Api from "../api/api";
import CarrierService from "../services/carrier_service";
import classNames from "classnames";
import documentEditor from "./document_editor";
import DataStoreService from "./data_store_service";
import DocumentBrowser from "./react_document_browser";
import DocumentIndexerService from "./document_indexer_service";
import DocumentsService from "./documents_service";
import DocumentTypesSetter from "./indexer/document_types_setter";
import EmailHelper from "../helpers/email_message";
import FactorInvoice from "./indexer/factor_invoice";
import FactorInvoicesService from "./factor_invoices_service";
import "../stores/factor_invoices_store";
import IndexerHeader from "./indexer/indexer_header";
import DocumentBrowserPagination from "../helpers/document_browser_pagination";
import PresenceList from "./presence";
import UnidentifiedDocumentHelper from "../helpers/unidentified_document";
import WaitingSpinner from "../components/waiting_spinner";
import { GroupedDocumentBrowserModel, DocumentBatchGroupCreator } from "./grouped_document_browser_model";
import { History } from "react-router";
import { IndexerProgress } from "./progress_bars";
import allowedAsPod from "../helpers/allowed_as_pod";
import hotkeys from "../util/hotkeys";
import { setPOD } from "../helpers/documents";
var FactorInvoiceExtractDataPage = React.createClass({
  mixins: [History],
  getInitialState: function() {
    return {
      loaded: false,
      documentBatches: [],
      browserExpanded: false,
      continueWithoutInvoiceInformation: false,
      reviewingAuditFlags: false,
      saving: false,
      viewingActivity: false
    };
  },
  updateData: function(props, page) {
    var buildDocumentModel = (documentBatches, invoiceId, stateDocumentModel) => {
      if (_.isEmpty(documentBatches)) return null;
      const currentPage = page || (stateDocumentModel ? stateDocumentModel.selectedPage : null);
      return new GroupedDocumentBrowserModel(
        new DocumentBatchGroupCreator(documentBatches, function(doc) {
          return doc.factor_invoice_id === invoiceId;
        }),
        function() {
          return false;
        },
        currentPage
      );
    };
    var getCarrier = (invoice) => {
      return CarrierService.carrierService.carrierWithId(
        invoice.carrier_id
      );
    };
    var updateState = (documentModel, leftDocumentModel, invoice, documentBatches) => {
      const hasDocuments = !_.isEmpty(invoice.document_ids);
      const documentIndexerService = hasDocuments ? new DocumentIndexerService(
        {},
        DataStoreService,
        Api.Account,
        this.props.location
      ) : null;
      this.setState({
        documentModel,
        documentIndexerService,
        factorInvoice: invoice,
        documentBatches,
        email: this.findEmail(documentBatches),
        leftDocumentModel,
        loaded: true
      });
    };
    var carrier = FactorInvoicesService.getWithId(props.params.factorInvoiceId).then((invoice) => {
      if (invoice.with_includes) {
        return Promise.resolve(invoice);
      }
      return FactorInvoicesService.fetchWithIDAndReturnPromise(invoice.id);
    }).then((invoice) => {
      DocumentsService.getDocumentBatches(
        invoice.document_batch_ids,
        (db) => db.documents
      ).then((documentBatches) => {
        documentBatches.forEach((db) => DocumentsService.updateDocuments(db.documents));
        updateState(
          buildDocumentModel(documentBatches, invoice.id, this.state.documentModel),
          buildDocumentModel(documentBatches, invoice.id, this.state.leftDocumentModel),
          invoice,
          documentBatches
        );
      });
      return invoice;
    }).then((invoice) => {
      return getCarrier(invoice);
    });
    this.setState({ carrier });
    this.resetViewAfterAddingDocument();
  },
  resetViewAfterAddingDocument: function() {
    if (this.state.documentModel) {
      if (UnidentifiedDocumentHelper.setPageFromUnidentifiedDocument(this.state.documentModel)) {
        this.setState({ selectedComponent: "Document" });
        this.editDocumentType();
        this.setState(
          { selectedComponent: "Document" },
          () => this.setState({ selectedComponent: null })
        );
      }
    }
  },
  documentBatchId: function() {
    return this.props.params.batchId && parseInt(this.props.params.batchId);
  },
  originalDocumentBatchId: function() {
    const query = this.props.location && this.props.location.query;
    if (query) {
      const next = query.next;
      if (next) {
        const matchResult = next.match(/\/index-document-batches\/(\d+)/);
        if (matchResult) {
          return matchResult[1];
        }
      }
    }
    return null;
  },
  componentWillReceiveProps: function(newProps) {
    this.updateData(newProps);
  },
  componentWillUnmount: function() {
    $(DataStoreService).on(
      "DataStoreService:documentPageReplaced",
      this.handlePageReplaced
    );
    $(DataStoreService).on(
      "DataStoreService:documentGroupUpdated",
      this.handleDocumentGroupUpdated
    );
    $(DataStoreService).on(
      "DataStoreService:documentBatchUpdated",
      this.handleDocumentBatchUpdated
    );
    hotkeys.unlistenInComponent(this);
  },
  componentDidMount: function() {
    $(DataStoreService).on(
      "DataStoreService:documentPageReplaced",
      this.handlePageReplaced
    );
    $(DataStoreService).on(
      "DataStoreService:documentGroupUpdated",
      this.handleDocumentGroupUpdated
    );
    $(DataStoreService).on(
      "DataStoreService:documentBatchUpdated",
      this.handleDocumentBatchUpdated
    );
    this.updateData(this.props);
    hotkeys.listenInComponent(this, AccountsPayable, {
      "nextPage": _.partial(this.changePage, "next"),
      "prevPage": _.partial(this.changePage, "previous"),
      "togglePOD": this.togglePOD
    });
  },
  handlePageReplaced(_event, page) {
    if (page) {
      const currentPage = this.state.documentModel && this.state.documentModel.selectedPage;
      const isUpdatedVersionOfCurrentPage = currentPage && currentPage.document_id === page.document_id && currentPage.number === page.number;
      if (isUpdatedVersionOfCurrentPage) {
        this.updateData(this.props, page);
      } else {
        this.updateData(this.props);
      }
    }
  },
  handleDocumentBatchUpdated(_event, _documentBatch) {
    this.updateData(this.props);
  },
  handleDocumentGroupUpdated(_event, _documentGroup) {
    this.updateData(this.props);
  },
  findEmail: function(documentBatches) {
    return _.chain(documentBatches).pluck("email_message").first().value();
  },
  completionContext: function() {
    if (this.hasMore()) {
      return "and continue to the next Group";
    } else {
      return "and return to the Dashboard";
    }
  },
  toggleDocumentData: function(document, field) {
    if (field === "includesPOD") {
      setPOD(document, !document.is_pod);
    } else {
      document.data[field] = !document.data[field];
    }
    this.forceUpdate();
    Api.Documents.save(document).then(this.update);
  },
  toggleClientDebtorOnBol: function(invoice) {
    this.setState({ saving: true });
    invoice.client_or_debtor_on_bol = !invoice.client_or_debtor_on_bol;
    this.forceUpdate();
    Api.FactorInvoices.toggleClientOrDebtorOnBol(invoice.id, invoice.client_or_debtor_on_bol, invoice.data.auditFlags).then((_data) => {
      this.setState({ saving: false });
    });
  },
  allPages() {
    return _.chain(this.state.documentModel.allDocuments()).map((d) => d.pages).flatten().value();
  },
  currentPageIndex() {
    return _.findIndex(
      this.allPages(),
      (p) => this.state.documentModel.selectedPage.id === p.id
    );
  },
  goToPageAtIndex(i) {
    const desiredPage = this.allPages()[i];
    if (desiredPage) {
      this.state.documentModel.selectPage(desiredPage);
      this.forceUpdate();
    }
  },
  nextPage(event) {
    event.preventDefault();
    event.stopPropagation();
    const currentPageIndex = this.currentPageIndex();
    if (currentPageIndex < 0) return;
    this.goToPageAtIndex(currentPageIndex + 1);
  },
  prevPage(event) {
    event.preventDefault();
    event.stopPropagation();
    const currentPageIndex = this.currentPageIndex();
    if (currentPageIndex <= 0) return;
    this.goToPageAtIndex(currentPageIndex - 1);
  },
  togglePOD(event) {
    event.preventDefault();
    event.stopPropagation();
    const document = this.state.documentModel.selectedDocument;
    if (allowedAsPod(document)) {
      this.toggleDocumentData(document, "includesPOD");
    }
  },
  render: function() {
    if (this.state.loaded) {
      return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "document-container" }, this.header(), this.possibleIndexerProgressBar(), this.mainContent(), /* @__PURE__ */ React.createElement("div", { id: "presence" }, /* @__PURE__ */ React.createElement(
        PresenceList,
        {
          location: this.props.location,
          batchId: this.documentBatchId() || this.originalDocumentBatchId()
        }
      ))));
    } else {
      return /* @__PURE__ */ React.createElement(WaitingSpinner, { when: true });
    }
  },
  mainContent() {
    if (this.state.reviewingAuditFlags) {
      return /* @__PURE__ */ React.createElement("div", { className: "document-indexer__main-body load-detail__main" }, /* @__PURE__ */ React.createElement(
        AuditFlagReview,
        {
          onCancel: this.cancelAuditFlagReview,
          onContinue: this.cancelAuditFlagReview,
          auditFlags: this.state.auditReview.auditFlags,
          factorInvoice: this.state.auditReview.factorInvoice,
          documentIds: this.state.auditReview.documentIds,
          model: this.state.documentModel,
          location: this.props.location
        }
      ));
    } else {
      return /* @__PURE__ */ React.createElement("div", { className: "document-indexer__main-body load-detail__main" }, this.factorInvoiceOrLeftSideBrowser(), this.documentBrowser());
    }
  },
  possibleIndexerProgressBar: function() {
    if (this.state.factorInvoice.state !== "abandoned") {
      return /* @__PURE__ */ React.createElement(
        IndexerProgress,
        {
          stepNumber: 4,
          location: this.props.location,
          batchId: this.documentBatchId()
        }
      );
    }
  },
  changePage(direction, event) {
    DocumentBrowserPagination.changePage(
      this.state.documentModel,
      direction,
      event
    );
    this.forceUpdate();
  },
  update: function() {
    this.updateData(this.props);
  },
  header: function() {
    if (this.state.email) {
      return /* @__PURE__ */ React.createElement("div", { className: "document-indexer__header" }, /* @__PURE__ */ React.createElement(
        IndexerHeader,
        {
          email: this.state.email,
          actions: this.actions(),
          ignoreEntry: this.ignoreEntry,
          canIgnoreEntry: !this.state.factorInvoice
        }
      ));
    }
  },
  ignoreEntry: function() {
    var onDone = this.props.location.query["onDone"] || "/dashboard";
    return Api.DocumentBatches.ignore(this.props.params.batchId).then(
      function() {
        this.history.pushState(null, onDone);
      }.bind(this),
      _.identity
    );
  },
  openThumbnailLeft: function(group, page) {
    this.setState({ leftSelected: { group, page } });
  },
  closeLeftSideDocumentBrowser: function() {
    this.setState({ leftSelected: null });
  },
  typeComplete() {
    this.forceUpdate();
    this.setState({ editingDocumentType: false });
  },
  typeUpdate(document) {
    this.forceUpdate();
    Api.Documents.save(document);
  },
  factorInvoiceOrLeftSideBrowser: function() {
    if (this.state.browserExpanded) return null;
    if (this.state.leftSelected) {
      return /* @__PURE__ */ React.createElement("div", { className: "xlarge-4 small-5 column document-indexer__left-side-document-browser-area" }, /* @__PURE__ */ React.createElement("div", { className: "document-indexer__left-side-document-browser" }, /* @__PURE__ */ React.createElement(
        DocumentBrowser,
        {
          model: this.state.leftDocumentModel || {},
          leftSelected: true,
          closeBrowser: this.closeLeftSideDocumentBrowser,
          collapseSingleGroup: true,
          canEditDocumentType: false,
          allowsEditing: false,
          allowsEditingPodStatus: false
        }
      )));
    } else {
      if (this.isEditingDocumentType()) {
        return this.documentSetter();
      } else {
        return this.factorInvoice();
      }
    }
  },
  documentSetter() {
    return /* @__PURE__ */ React.createElement("div", { className: "small-5 xlarge-4 column load-detail__action-area" }, /* @__PURE__ */ React.createElement(
      DocumentTypesSetter,
      {
        model: this.state.documentModel,
        onUpdate: this.typeUpdate,
        onComplete: this.typeComplete,
        documentIndexerService: this.state.documentIndexerService
      }
    ));
  },
  activeDocuments() {
    return this.state.documentModel && this.state.documentModel.activeDocuments();
  },
  allDocuments() {
    return this.state.documentModel && this.state.documentModel.allDocuments();
  },
  factorInvoiceIdFromParams(params) {
    return params && params.factorInvoiceId && parseInt(params.factorInvoiceId);
  },
  factorInvoice() {
    const factorInvoiceId = this.factorInvoiceIdFromParams(this.props.params);
    return /* @__PURE__ */ React.createElement("div", { className: "small-5 xlarge-4 column load-detail__action-area" }, /* @__PURE__ */ React.createElement(
      FactorInvoice,
      {
        factorInvoiceId,
        model: this.state.documentModel,
        activeDocuments: this.activeDocuments(),
        params: this.props.params,
        confirmAndSubmit: true,
        allDocuments: this.allDocuments(),
        location: this.props.location,
        documentBatches: this.state.documentBatches,
        hasMore: this.hasMore(),
        onReviewAuditFlags: this.beginAuditFlagReview,
        continueWithoutInvoiceInformation: this.state.continueWithoutInvoiceInformation,
        onContinueWithoutInvoiceInformation: this.continueWithoutInvoiceInformation,
        carrier: this.state.carrier
      }
    ));
  },
  beginAuditFlagReview(factorInvoice, flags, documentIds) {
    this.setState({
      auditReview: {
        auditFlags: flags,
        factorInvoice,
        documentIds
      },
      reviewingAuditFlags: true
    });
  },
  cancelAuditFlagReview() {
    this.setState({ reviewingAuditFlags: false, auditReview: void 0 });
  },
  continueWithoutInvoiceInformation(shouldContinue) {
    this.setState({ continueWithoutInvoiceInformation: shouldContinue });
  },
  isEditingDocumentType() {
    return this.state.editingDocumentType;
  },
  hasMore: function() {
    return this.props.location.query["hasMore"] === "true";
  },
  batchUrl: function() {
    if (this.documentBatchId()) {
      let onDone = "/dashboard";
      if (this.props.location && this.props.location.query.onDone) {
        onDone = this.props.location.query.onDone;
      }
      return "/index-document-batches/" + this.documentBatchId() + "?onDone=" + encodeURIComponent(onDone);
    } else {
      return null;
    }
  },
  actions: function() {
    var actions = [];
    const batchUrl = this.batchUrl();
    if (batchUrl) {
      actions.push([
        "Return to Batch",
        () => {
          this.history.pushState(null, batchUrl);
        }
      ]);
    }
    return actions;
  },
  editDocumentType: function() {
    this.setState({ editingDocumentType: true });
  },
  invoiceActivityItems: function() {
    if (this.state.factorInvoice) {
      return this.state.factorInvoice.activity_items || [];
    } else {
      return [];
    }
  },
  toggleMarkIllegibleData: function(document, page) {
    Api.DocumentPages.markIllegible(page);
  },
  documentBrowser: function() {
    const classes = classNames({
      "x-large-6": !this.state.browserExpanded,
      "small-5": !this.state.browserExpanded,
      "small-10": this.state.browserExpanded,
      "column": true,
      "document-indexer__document-side": true
    });
    return /* @__PURE__ */ React.createElement("div", { className: classes }, /* @__PURE__ */ React.createElement(
      DocumentBrowser,
      {
        model: this.state.documentModel || {},
        selectedComponent: this.state.selectedComponent,
        location: this.props.location,
        leftSelected: this.state.leftSelected,
        isConfirmAndSubmit: true,
        onContextMenu: this.openThumbnailLeft,
        canEditDocumentType: true,
        editDocumentType: this.editDocumentType,
        toggleDocumentData: this.toggleDocumentData,
        currentInvoice: this.state.factorInvoice,
        toggleMarkIllegibleData: this.toggleMarkIllegibleData,
        toggleClientDebtorCheck: this.toggleClientDebtorOnBol,
        savingInvoice: this.state.saving,
        allowsEditing: true,
        expandBrowser: this.expandOrCompressBrowser,
        browserExpanded: this.state.browserExpanded,
        additionalComponents: this.additionalBrowserComponents(),
        initialSelectedComponent: this.initialDocumentBrowserComponent(),
        allowsEditingPodStatus: true
      }
    ));
  },
  additionalBrowserComponents: function() {
    return _.compact([
      this.possibleMessageBrowserComponent(),
      this.activityBrowserComponent()
    ]);
  },
  possibleMessageBrowserComponent: function() {
    const emails = this.state.factorInvoice.email_messages || [];
    if (emails.length > 0)
      return {
        label: "Message",
        component: EmailHelper.emailMessages(
          this.state.factorInvoice.email_messages,
          this.documentFromEmail()
        )
      };
  },
  documentFromEmail: function() {
    if (this.state.factorInvoice && this.state.factorInvoice.state !== "approved") {
      return this.getDocumentFromEmail;
    }
  },
  getDocumentFromEmail: function(emailMessage) {
    const model = this.state.documentModel;
    const groupId = model.selectedDocument.document_group_id;
    return documentEditor.documentFromEmail(emailMessage.id, groupId);
  },
  activityBrowserComponent: function() {
    return {
      label: "Activity",
      component: ActivityStreamHelper.invoiceActivity(this.invoiceActivityItems())
    };
  },
  initialDocumentBrowserComponent() {
    return this.props.location.query.activeDocumentTab;
  },
  expandOrCompressBrowser() {
    this.setState({ browserExpanded: !this.state.browserExpanded });
  }
});
export default FactorInvoiceExtractDataPage;
